export const formFields = [
    {
        label: 'Company Name*',
        type: 'text',
        desc: "",
        name: 'companyName',
        placeholder: 'Enter Company Name',
        disabled: false,
        componentType: 'input',
        errorText: 'Company Name'
    },
    {
        label: 'Membership Number*',
        type: 'text',
        name: 'membershipNumber',
        placeholder: 'Enter Membership Number',
        disabled: true,
        componentType: 'input',
        errorText: 'Membership Number'
    },
    {
        label: 'Customer Name*',
        type: 'text',
        name: 'customerName',
        placeholder: 'Enter Customer Name',
        disabled: false,
        componentType: 'input',
        errorText: 'Customer Name'
    },
    {
        label: 'Phone*',
        type: 'text',
        componentType: 'input',
        name: 'mobileNumber',
        placeholder: 'Enter Phone',
        disabled: false,
        errorText: 'Phone'
    },
    {
        label: 'Email*',
        type: 'text',
        componentType: 'input',
        name: 'emailAddress',
        placeholder: 'Enter Email',
        disabled: false,
        errorText: 'Email'
    },
];

